import { Injector } from "@angular/core";
import { environment } from "src/environments/environment";
import {
    Chart,
    PointElement,
    ArcElement,
    CategoryScale,
    LinearScale,
    LineController,
    LineElement,
    TimeScale,
    Title,
    Tooltip,
    BarElement,
    BarController,
    DoughnutController
} from 'chart.js';

export async function appInit(injector: Injector) {

    if (environment.paddleSandbox) {
        // @ts-ignore
        window.Paddle.Environment.set('sandbox');
    }
    // @ts-ignore
    window.Paddle.Setup({ vendor: environment.vendorId });

    //Initialize chart
    Chart.register(PointElement,
        CategoryScale,
        LinearScale,
        LineController,
        LineElement,
        BarElement,
        BarController,
        DoughnutController,
        ArcElement,
        TimeScale,
        Title,
        Tooltip);
    Chart.defaults.font.size = 14;
    Chart.defaults.font.family = 'Inter';
    return Promise.resolve();
}

